import { FormGroup } from "@blueprintjs/core";
import type { ExtraFieldTypeMedia } from "@package/ui-gql/index-data-access";
import { get, set } from "lodash";
import { useMemo } from "react";
import { MediaTagSelector } from "../../MediaTagSelector/MediaTagSelector";
import type { ServiceDataFormFieldBaseProps } from "./ServiceDataFormFieldEmpty";

type ServiceDataFormFieldMediaProps = ServiceDataFormFieldBaseProps & {
  field: ExtraFieldTypeMedia;
};

function ServiceDataFormFieldMediaContent({
  data,
  field,
  onSourceChanged,
}: ServiceDataFormFieldMediaProps) {
  const value = useMemo<string | undefined>(
    () => get(data, field.source) ?? undefined,
    [data, field.source],
  );

  return (
    <FormGroup label={field.label}>
      <MediaTagSelector
        fill
        large
        minimal
        disabled={false}
        id={value}
        onRemoveMedia={() => {
          onSourceChanged((draft) => {
            set(draft, field.source, undefined);
          });
        }}
        onSelectMedia={(mediaId) => {
          onSourceChanged((draft) => {
            set(draft, field.source, mediaId);
          });
        }}
      />
    </FormGroup>
  );
}

export function ServiceDataFormFieldMedia({
  field,
  onSourceChanged,
  data,
}: ServiceDataFormFieldBaseProps) {
  if (field.__typename === "ExtraFieldTypeMedia") {
    return (
      <ServiceDataFormFieldMediaContent
        field={field}
        data={data}
        onSourceChanged={onSourceChanged}
      />
    );
  }

  return null;
}
